import styled from "@emotion/styled";
import { IconButton, Typography } from "@mui/material";
import { mediumMobile, mobile } from "commons/styled.components";
import { COLORS } from "utils/colors";

export const DialogContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  background: #fcfcfc;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  border-radius: 0.625rem;
  position: relative;
  min-width: 26rem;

  ${mobile(`
    padding: 2rem 1.5rem;
    min-width: 0;
  `)}

  ${mediumMobile(`
    padding: 1.5rem 1rem;
  `)}
`;

export const DialogCloseButton = styled(IconButton)`
  height: 1.5rem;
  width: 1.5rem;
  position: absolute;
  top: 0.625rem;
  right: 0.625rem;
`;

export const HeadingText = styled(Typography)`
  font-weight: 500;
  font-size: 1.3rem;
  color: #000000;
  text-align: center;

  ${mobile(`
    font-size: 1.5rem;
  `)}
`;

export const PointsBadge = styled(Typography)`
  color: ${COLORS.BRAND_DEFAULT_COLOR};
  font-weight: 700;
  font-size: 1.75rem;
  margin: 0.75rem 0;
`;

export const MessageText = styled(Typography)`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #6b6b6b;
  text-align: center;
  margin-bottom: 0.75rem;
`;

export const SuggestedSurveyLabel = styled(Typography)`
  align-self: flex-start;
  font-weight: 500;
  font-size: 0.75rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #9a9a9a;
  margin-top: 0.5rem;
`;

export const SuggestedSurveyWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin: 0.5rem 0 1.5rem;
  padding: 0.85rem 1rem;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-left: 3px solid ${COLORS.BRAND_DEFAULT_COLOR};
  border-radius: 0.5rem;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.15s ease;

  :hover {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
  }

  ${mobile(`
    padding: 0.65rem 0.75rem;
    gap: 0.5rem;
  `)}
`;

export const SuggestedSurveyInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  flex-wrap: nowrap;
  gap: 0.5rem;
  min-width: 0;
  flex: 1;
`;

export const SuggestedSurveyName = styled(Typography)`
  font-weight: 600;
  font-size: 0.95rem;
  color: #000000;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;

  ${mobile(`
    font-size: 0.85rem;
  `)}
`;

export const SuggestedSurveyPoints = styled(Typography)`
  font-weight: 600;
  font-size: 0.85rem;
  color: ${COLORS.BRAND_DEFAULT_COLOR};
  white-space: nowrap;
  flex-shrink: 0;
`;

export const SuggestedSurveyTime = styled(Typography)`
  font-weight: 400;
  font-size: 0.85rem;
  color: #9a9a9a;
  white-space: nowrap;
  flex-shrink: 0;

  ${mobile(`
    display: none;
  `)}
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 1rem;
  margin-top: 0.5rem;

  ${mediumMobile(`
    flex-direction: column;
    gap: 0.75rem;
  `)}
`;
